// src/api/vehicle.js
import request from '@/utils/request'

// 车辆列表
export function getVehicleList(params) {
  return request.get('/wms/vehicle/list', { params })
}

// 新增车辆（带 password）
export function createVehicle(data) {
  return request.post('/wms/vehicle', data)
}

// 车辆详情
export function getVehicleDetail(id) {
  return request.get(`/wms/vehicle/${id}`)
}

// 修改车辆（支持 password 可选）
export function updateVehicle(id, data) {
  return request.put(`/wms/vehicle/${id}`, data)
}

// 删除车辆（软删）
export function deleteVehicle(id) {
  return request.delete(`/wms/vehicle/${id}`)
}